
export class VolunteerTaskRecord {
    id: number | null = null
    scheduledDate: string | null = null;
    scheduledDurationHrs: number | null = null; // specific to task, may be different than seriesTaskDurationHrs (default)
    seriesId: number | null = null;
    stage: string | null = null;
    type: string | null = null;
    buildingId: string | null = null;
    volunteerId: string | null = null;
    modifiedBy: string | null = null;
    modifiedAt: Date | null = null;
    status: number | null = null;
    notes: string | null = null;
    lastValidRutId?: number;
}

export class VolunteerTaskViewRecord extends VolunteerTaskRecord{
    scheduledDateText: string | null = null;
    buildingName: string | null = null;
    volunteerName: string | null = null;
    modifiedByName : string | null = null;
    modifiedAtText: string | null = null;
    statusName: string | null = null;
    endDate: string | null = null;
    endDateText: string | null = null;
    taskPoints: Array<VolunteerTaskViewTaskPoint> | null = null;
    seriesPosition: number | null = null;
    seriesMaxCnt: number | null = null;
    seriesTaskDurationHrs: number | null = null;
    seriesTaskIntervalHrs: number | null = null;
    lastActiveTaskPointId: number | null;
    lastCallStartTime: string | null;
    lastCallDuration: number | null;
}

export type VolunteerTaskViewTaskPoint = {
    id: number;
    pointId: string;
    commonName: string;
    volunteerPointId: string;
    callsPlacedCnt: number;
    targetCallCnt: number;
    lastCallTime: string;
}
